import Process from './Process'

export default Process



// WEBPACK FOOTER //
// ./src/components/Orders/Process/index.js